module.exports = __webpack_public_path__ + "img/as2.865741ab.png";